import { ProjectChild } from "shared/types/Project"

export function filterSiblingsByType({
  siblings,
  childType
}: {
  siblings: ProjectChild[] | null | undefined
  childType: string
}): ProjectChild[] {
  if (!siblings) {
    return []
  }

  return siblings.filter(child => child.__typename === childType)
}
